import React from 'react';
import { useTranslate } from '../../../lib';
import { SelectNesting } from '../../common/Inputs/Select';
import { InputNesting } from '../../common/Inputs/Input';

export default function AIpersonaDetails({
  showAiPersonaDetails,
  setShowAiPersonaDetails,
  personaMood,
  setPersonaMood,
  personaResponseLength,
  setPersonaResponseLength,
  personaTalkativeMood,
  setPersonaTalkativeMood,
}) {
  const { t } = useTranslate();

  return (
    <>
      {/* ENCABEZADO */}
      <div
        className="d-flex flex-row align-items-center justify-content-between w-100 mt-1 shadow_box"
        style={{
          backgroundColor: '#0088ff09',
          padding: 10,
          borderRadius: '10px 10px 0 0',
        }}
      >
        <div className="d-flex flex-row align-items-center w-100">
          <div
            className="w-100"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h2 onClick={() => setShowAiPersonaDetails(!showAiPersonaDetails)} className="m-0" style={{ color: '#0B5FA3', fontSize: 15, cursor: "pointer" }}>
              {t('menu.genai.aiPersonaDetails')}
            </h2>

            {/* Botón Mostrar */}
            <button
              id="arrow-down-btn"
              style={{ display: !showAiPersonaDetails ? 'block' : 'none' }}
              className="ml-3"
              type="button"
              onClick={() => setShowAiPersonaDetails(true)}
            >
              <img src="/icons/arrow_down.png" style={{ width: 15 }} alt="" />
            </button>

            {/* Botón Ocultar */}
            <button
              id="arrow-down-btn"
              style={{ display: showAiPersonaDetails ? 'block' : 'none' }}
              className="ml-3"
              type="button"
              onClick={() => setShowAiPersonaDetails(false)}
            >
              <img src="/icons/arrow_up.png" style={{ width: 15 }} alt="" />
            </button>
          </div>
        </div>
      </div>

      {/* CONTENIDO DESPLEGABLE */}
      <div
        style={{
          display: showAiPersonaDetails ? 'flex' : 'none',
          backgroundColor: '#0088ff09',
          padding: '5px 10px 10px 10px',
        }}
        className="flex-row flex-wrap pt-5"
      >
        {/* Persona Mood */}
        <div className='d-flex flex-column w-100' style={{ flexGrow: '1', marginTop: 0 }}>

          <div className='flex flex-column mt-1'>
            <label style={{ fontSize: 14, color: "#2E2E2E", fontWeight: '700', marginBottom: 8 }}>{t('menu.genai.mood')}</label>
            <div className='flex flex-column'>
              {[
                { value: 'friendly', label: t('menu.genai.moodOptions.friendly'), desc: t('menu.genai.moodDescriptions.friendly') },
                { value: 'angry', label: t('menu.genai.moodOptions.angry'), desc: t('menu.genai.moodDescriptions.angry') },
                { value: 'sad', label: t('menu.genai.moodOptions.sad'), desc: t('menu.genai.moodDescriptions.sad') },
                { value: 'unfriendly', label: t('menu.genai.moodOptions.unfriendly'), desc: t('menu.genai.moodDescriptions.unfriendly') },
                { value: 'excited', label: t('menu.genai.moodOptions.excited'), desc: t('menu.genai.moodDescriptions.excited') },
                { value: 'calm', label: t('menu.genai.moodOptions.calm'), desc: t('menu.genai.moodDescriptions.calm') },
              ].map(opt => (
                <div key={opt.value} className='mb-2'>
                  <label className='flex flex-row items-center' style={{ cursor: 'pointer', fontWeight: personaMood === opt.value ? '700' : '400' }}>
                    <input
                      type='radio'
                      name='persona_mood'
                      value={opt.value}
                      checked={personaMood === opt.value}
                      onChange={() => setPersonaMood(opt.value)}
                      style={{ marginRight: 8 }}
                    />
                    <span style={{ fontSize: 15 }}>{opt.label}</span>
                  </label>
                  <span style={{ fontSize: 13, color: '#6B6B6B', marginLeft: 22, display: 'block' }}>{opt.desc}</span>
                </div>
              ))}
            </div>
          </div>

          <div className='flex flex-column mt-2'>
            <label style={{ fontSize: 14, color: "#2E2E2E", fontWeight: '700', marginBottom: 8 }}>{t('menu.genai.responseLength')}</label>
            <div className='flex flex-column'>
              {[
                { value: 'short', label: t('menu.genai.responseLengthOptions.short'), desc: '' },
                { value: 'medium', label: t('menu.genai.responseLengthOptions.medium'), desc: '' },
                { value: 'long', label: t('menu.genai.responseLengthOptions.long'), desc: '' }
              ].map(opt => (
                <div key={opt.value} className='mb-2'>
                  <label className='flex flex-row items-center' style={{ cursor: 'pointer', fontWeight: personaResponseLength === opt.value ? '700' : '400' }}>
                    <input
                      type='radio'
                      name='persona_response_length'
                      value={opt.value}
                      checked={personaResponseLength === opt.value}
                      onChange={() => setPersonaResponseLength(opt.value)}
                      style={{ marginRight: 8 }}
                    />
                    <span style={{ fontSize: 15 }}>{opt.label}</span>
                  </label>
                  <span style={{ fontSize: 13, color: '#6B6B6B', marginLeft: 22, display: 'block' }}>{opt.desc}</span>
                </div>
              ))}
            </div>
          </div>
          <div className='flex flex-column mt-2'>
            <label style={{ fontSize: 14, color: "#2E2E2E", fontWeight: '700', marginBottom: 8 }}>{t('menu.genai.talkativeMood')}</label>
            <div className='flex flex-column'>
              {[
                { value: 'yes', label: t('menu.genai.talkativeOptions.yes'), desc: t('menu.genai.talkativeDescriptions.yes') },
                { value: 'no', label: t('menu.genai.talkativeOptions.no'), desc: t('menu.genai.talkativeDescriptions.no') },
              ].map(opt => (
                <div key={opt.value} className='mb-2'>
                  <label className='flex flex-row items-center' style={{ cursor: 'pointer', fontWeight: personaTalkativeMood === opt.value ? '700' : '400' }}>
                    <input
                      type='radio'
                      name='persona_talkative_mood'
                      value={opt.value}
                      checked={personaTalkativeMood === opt.value}
                      onChange={() => setPersonaTalkativeMood(opt.value)}
                      style={{ marginRight: 8 }}
                    />
                    <span style={{ fontSize: 15 }}>{opt.label}</span>
                  </label>
                  <span style={{ fontSize: 13, color: '#6B6B6B', marginLeft: 22, display: 'block' }}>{opt.desc}</span>
                </div>
              ))}
            </div>
          </div>

        </div>




      </div>
    </>
  );
}

